import Cookies from 'js-cookie'
import apiClient, { setAuthHeader } from './basicapi'

function verifyUserToken() {
  return new Promise((resolve, reject) => {
    return resolve(Cookies.get('basicAuthToken'))
  })
}

function loggingIn(token) {
  setAuthHeader(token)
  Cookies.set('basicAuthToken', token, { expires: 7 })
  return apiClient.get('contactadmin')
}

export { verifyUserToken, loggingIn }
